import axios from 'axios';
import { normalizeGetTableQuery } from '@/utils/globalHelpers';

export class GlobalService {
  async login(params) {
    return await axios.post('/api/v1/login', params);
  }
  async getCurrentUser() {
    return await axios.get('/api/v1/portal/me');
  }
  async getOrderInformation(orderId) {
    return await axios.get(`/api/v1/order/${orderId}`);
  }
  async setDestinationAddress(orderId, data) {
    return await axios.post(`/api/v1/portal/order/setReceiverAddress/${orderId}`, data);
  }
  async setOriginAddress(orderId, data) {
    return await axios.post(`/api/v1/portal/order/setOriginAddress/${orderId}`, data);
  }
  async setSenderInfo(orderId, data) {
    return await axios.post(`/api/v1/portal/order/setSenderInfo/${orderId}`, data);
  }
  async logOut() {
    return await axios.post(`/api/v1/portal/logout`);
  }
  async getSettings() {
    return await axios.get('/api/v1/app-settings');
  }
  async getCustomerList() {
    return await axios.get('/api/v1/portal/customer/list');
  }
  async getCustomerById(id) {
    return await axios.get(`/api/v1/portal/customer/${id}`);
  }
  async getDashboardData() {
    return await axios.get(`/api/v1/portal/dashboard`);
  }
  async getNotes(essenceType, essenceId) {
    return await axios.get(`/api/v1/portal/note?type=${essenceType}&id=${essenceId}`);
  }
  async setOrderPackageInfo(orderId, data) {
    return await axios.post(`/api/v1/portal/order/setPackageInfo/${orderId}`, data);
  }
  async changePinStatus(noteId) {
    return await axios.get(`/api/v1/portal/note/changePin/${noteId}`);
  }
  async createNote(data) {
    return await axios.post(`/api/v1/portal/note`, data);
  }
  async editNote(noteId, data) {
    return await axios.put(`/api/v1/portal/note/${noteId}`, data);
  }
  async getSalesReport(data, lazyParams) {
    const params = normalizeGetTableQuery(lazyParams);
    params.start_date = data.start_date;
    params.end_date = data.end_date;
    params.order_type = data.order_type;
    params.sales_person_id = data.sales_person_id;
    params.coordinator_id = data.coordinator_id;
    params.customer_id = data.customer_id;
    // params.status = data.status;
    return await axios.get(`/api/v1/portal/sales-report`, { params });
  }
  async essenceDelete(essenceType, essenceId) {
    const isEssenceTypeValid = [
      'country',
      'city',
      'airline',
      'service',
      'packageItem',
      'trackingStatus',
      'orderTracking',
      'paymentMethod',
      'baseLocation',
      'reference',
      'referenceFinancial',
      'CarryingTerms',
      'CustomerAddress',
      'currency',
      'Currency',
      'CustomerContact',
      'CustomerSalesPerson',
      'CustomerLead',
      'customer',
      'admin',
      'note',
      'agent',
      'Attachment',
      'agency'
    ].includes(essenceType);
    if (!isEssenceTypeValid) throw new Error('Essence type is not valid');
    let url = '';
    switch (essenceType) {
      case 'country':
        url = `/api/v1/portal/country/${essenceId}`;
        break;
      case 'city':
        url = `/api/v1/portal/city/${essenceId}`;
        break;
      case 'airline':
        url = `/api/v1/portal/airline/${essenceId}`;
        break;
      case 'service':
        url = `/api/v1/portal/service/${essenceId}`;
        break;
      case 'packageItem':
        url = `/api/v1/portal/packageItem/${essenceId}`;
        break;
      case 'trackingStatus':
        url = `/api/v1/portal/trackingStatus/${essenceId}`;
        break;
      case 'orderTracking':
        url = `/api/v1/portal/orderTracking/${essenceId}`;
        break;
      case 'paymentMethod':
        url = `/api/v1/portal/paymentMethod/${essenceId}`;
        break;
      case 'baseLocation':
        url = `/api/v1/portal/location/${essenceId}`;
        break;
      case 'reference':
        url = `/api/v1/portal/order/${essenceId}`;
        break;
      case 'referenceFinancial':
        url = `/api/v1/portal/orderFinancialTransaction/${essenceId}`;
        break;
      case 'CarryingTerms':
        url = `/api/v1/portal/carryingTerm/${essenceId}`;
        break;
      case 'CustomerAddress':
        url = `/api/v1/portal/customerAddress/${essenceId}`;
        break;
      case 'Currency':
      case 'currency':
        url = `/api/v1/portal/currency/${essenceId}`;
        break;
      case 'CustomerContact':
        url = `/api/v1/portal/customerContact/${essenceId}`;
        break;
      case 'CustomerSalesPerson':
        url = `/api/v1/portal/userCustomer/${essenceId}`;
        break;
      case 'CustomerLead':
        url = `/api/v1/portal/lead/${essenceId}`;
        break;
      case 'customer':
        url = `/api/v1/portal/customer/${essenceId}`;
        break;
      case 'admin':
        url = `/api/v1/portal/user/${essenceId}`;
        break;
      case 'note':
        url = `/api/v1/portal/note/${essenceId}`;
        break;
      case 'Attachment':
        url = `/api/v1/portal/attachment/${essenceId}`;
        break;
      case 'agent':
        url = `/api/v1/portal/agent/${essenceId}`;
        break;
      case 'agency':
        url = `/api/v1/agencies/${essenceId}`;
        break;
    }
    return await axios.delete(url);
  }
}

export default GlobalService;
